import resourceService from './resource_service';

const modelName = 'chemical';

const attributes = {
  name: '',
  color: '',
  description: '',
  code: 0,
  ppg: 0,
};

const relationships = {
  chemicalType: {
    jsonApi: 'hasOne',
    update: true,
  },
  chemicalManufacturer: {
    jsonApi: 'hasOne',
    update: true,
  },
};

export default resourceService(modelName, attributes, relationships);
